import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
export function AboutSection() {
  const {
    t
  } = useLanguage();
  return <section id="about" className="py-24 bg-white" data-id="element-26">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-27">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-28">
          <div data-id="element-29">
            <h2 className="text-sm font-bold tracking-widest text-brand-copper uppercase mb-3" data-id="element-30">
              {t('about.label')}
            </h2>
            <h3 className="text-3xl md:text-4xl font-light text-gray-900 mb-6 leading-tight" data-id="element-31">
              {t('about.title1')}{' '}
              <span className="font-semibold" data-id="element-32">{t('about.title2')}</span>
            </h3>
            <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-33">
              {t('about.p1')}
            </p>
            <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-34">
              {t('about.p2')}
            </p>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 border-t border-gray-100 pt-8" data-id="element-35">
              <div data-id="element-36">
                <div className="text-3xl font-light text-brand-copper mb-1" data-id="element-37">
                  20+
                </div>
                <div className="text-xs text-gray-500 font-medium uppercase tracking-wider" data-id="element-38">
                  {t('about.yearsExp')}
                </div>
              </div>
              <div data-id="element-39">
                <div className="text-3xl font-light text-brand-copper mb-1" data-id="element-40">
                  120+
                </div>
                <div className="text-xs text-gray-500 font-medium uppercase tracking-wider" data-id="element-41">
                  {t('about.countries')}
                </div>
              </div>
              <div data-id="element-42">
                <div className="text-3xl font-light text-brand-copper mb-1" data-id="element-43">
                  50+
                </div>
                <div className="text-xs text-gray-500 font-medium uppercase tracking-wider" data-id="element-44">
                  {t('about.varieties')}
                </div>
              </div>
              <div data-id="element-45">
                <div className="text-3xl font-light text-brand-copper mb-1" data-id="element-46">
                  8
                </div>
                <div className="text-xs text-gray-500 font-medium uppercase tracking-wider" data-id="element-47">
                  {t('about.series')}
                </div>
              </div>
            </div>
          </div>

          <div className="relative" data-id="element-48">
            <div className="aspect-[4/3] bg-brand-lightCopper/30 rounded-lg overflow-hidden relative border border-brand-lightCopper/50" data-id="element-49">
              {/* Placeholder for company image */}
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-50">
                <span className="text-brand-darkCopper/50 font-light tracking-widest" data-id="element-51">
                  SINGCLEAN MEDICAL
                </span>
              </div>
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-6 -left-6 w-48 h-48 bg-brand-bg -z-10 rounded-lg" data-id="element-52"></div>
          </div>
        </div>
      </div>
    </section>;
}